import React from 'react';

const InfoIcon = ({
  color = 'currentColor',
  className,
  width = '17px',
  height = '16px',
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1.6C4.97103 1.6 2.1 4.47103 2.1 8C2.1 11.529 4.97103 14.4 8.5 14.4C12.029 14.4 14.9 11.529 14.9 8C14.9 4.47103 12.029 1.6 8.5 1.6ZM8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0ZM8.5 4.8C8.05817 4.8 7.7 4.44182 7.7 4C7.7 3.55817 8.05817 3.2 8.5 3.2C8.94183 3.2 9.3 3.55817 9.3 4C9.3 4.44182 8.94183 4.8 8.5 4.8ZM8.49959 12.375C8.05776 12.375 7.69959 12.0168 7.69959 11.575V6.775C7.69959 6.33317 8.05776 5.975 8.49959 5.975C8.94142 5.975 9.29959 6.33317 9.29959 6.775V11.575C9.29959 12.0168 8.94142 12.375 8.49959 12.375Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};

export default InfoIcon;
